import React from 'react'
import { useUser } from "../../../../hooks/use-user";
import StartQuizepage from '../Mcq/Dashboard';
import QuestionPage from '../Mcq/QuestionPage';
const DashHome = () => {

  return (
    <>
   <StartQuizepage/>
    </>
  )
}

export default DashHome
